import React, { useMemo, useState } from 'react';
import WrappedAuthContainer from './containers/AuthContainer';
import LocationProvider from './containers/LocationProvider';
import { FiltersContextProvider } from './containers/contexts/filters.context/filters.context';
import BasketResolverProvider from './containers/BasketResolver';
import { MenuSkeletonPage } from './components/Skeletons/MenuPageSkeletons';

const DataReadyWrapper = ({
    /* eslint-disable react/prop-types */
    appReady,
    children,
    /* eslint-enable */
}) => {
    const {
        WrappedAuthContainer,
        FiltersContextProvider,
        BasketResolverProvider,
    } = appReady;

    const ready = useMemo(
        () => (!WrappedAuthContainer || !FiltersContextProvider || !BasketResolverProvider),
        [WrappedAuthContainer, FiltersContextProvider, BasketResolverProvider],
    );
    // console.log(WrappedAuthContainer, FiltersContextProvider, BasketResolverProvider);

    /* FALLBACK */
    if (ready) return <MenuSkeletonPage />;
    // eslint-disable-next-line react/jsx-no-useless-fragment
    return <>{children}</>;
};


export const useAppDataFetchingState = () => {
    const initialReadyState = {
        WrappedAuthContainer: false,
        LocationProvider: false,
        FiltersContextProvider: false,
        BasketResolverProvider: false,
    };
    const [appReady, setAppReady] = useState(initialReadyState);
    return [appReady, setAppReady];
};

export const AppDataAccessContainer = React.memo((props) => {
    const { onUserFetched, children } = props;
    const [appReady, setAppReady] = useAppDataFetchingState();

    return (
        <WrappedAuthContainer
            onUserFetched={onUserFetched}
            setAppReady={setAppReady}
            appReady={appReady}
        >
            <LocationProvider>
                <FiltersContextProvider
                    setAppReady={setAppReady}
                    appReady={appReady}
                >
                    <BasketResolverProvider
                        setAppReady={setAppReady}
                        appReady={appReady}
                    >
                        <DataReadyWrapper appReady={appReady}>
                            {children}
                        </DataReadyWrapper>
                    </BasketResolverProvider>
                </FiltersContextProvider>
            </LocationProvider>
        </WrappedAuthContainer>
    );
});
